import { useContext } from 'react'

import { MatrixContext } from '../contexts'

export const useMatrix = () => {
    const context = useContext(MatrixContext)
    // TODO: add additional context values, e.g. account data etc...
    return context
}
